import { render, staticRenderFns } from "./DetailsCycleItem.vue?vue&type=template&id=4d58e1fe&scoped=true&"
import script from "./DetailsCycleItem.vue?vue&type=script&lang=js&"
export * from "./DetailsCycleItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCycleItem.vue?vue&type=style&index=0&id=4d58e1fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d58e1fe",
  null
  
)

export default component.exports